import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

export enum YesNoCancelResult {
  Yes = 1,
  No = 2,
  Cancel = 3
};

export interface GlobalYesNoCancelDialogState {
  show: boolean,
  resolve: ((value: YesNoCancelResult | PromiseLike<YesNoCancelResult>) => void)|null,
  content: React.ReactNode | null,
};

export interface GlobalYesNoCancelDialogData {
  resolve: ((value: YesNoCancelResult | PromiseLike<YesNoCancelResult>) => void)|null,
  content: React.ReactNode | null,
};

const initialState:GlobalYesNoCancelDialogState = {
  show: false,
  resolve: null,
  content: null,
};

/**
 * Slice for controlling Global Yes No Dialog
 */
const globalYesNoCancelDialogSlice = createSlice({
  name: 'globalYesNoCancelDialog',
  initialState,
  reducers: {
    showGlobalYesNoCancelDialog: (state, action: PayloadAction<GlobalYesNoCancelDialogData>) => {
      state.show = true;
      state.resolve = action.payload.resolve;
      state.content = action.payload.content;
    },
    hideGlobalYesNoCancelDialog: (state) => {
      state.show = false;
      state.resolve = null;
      state.content = null;
    },
  }
});

export default globalYesNoCancelDialogSlice.reducer;

export const { showGlobalYesNoCancelDialog, hideGlobalYesNoCancelDialog } = globalYesNoCancelDialogSlice.actions;
